import { DateRangeRequest } from '@/modules/common/types/dto/date-range.dto';
import { CursorPaginationParametersRequest } from '@/modules/common/types/pagination-types';
import { TeamMemberStatusDTO } from '@/modules/common/types/team-member-status-dto';

/**
 * All active (non-archived) team member statuses.
 * Use this when loading members for selection (e.g. manager dropdowns)
 * to exclude archived members from results.
 */
export const NON_ARCHIVED_TEAM_MEMBER_STATUSES: TeamMemberStatusDTO[] = [
  TeamMemberStatusDTO.ACTIVE,
  TeamMemberStatusDTO.INVITED,
  TeamMemberStatusDTO.INVITE_EXPIRED,
  TeamMemberStatusDTO.BASIC,
  TeamMemberStatusDTO.PLACEHOLDER,
];

/**
 * Filter criteria for finding short team members
 * Matches FindShortTeamMembersFilterRequest from swagger
 */
export interface FindShortTeamMembersFilterRequest {
  searchString?: string;
  statuses?: TeamMemberStatusDTO[];
  isManager?: boolean;
  /**
   * The date when the user should match the given filter.
   * Shouldn't be specified together with `matchesWholePeriod`.
   */
  revisionDate?: string;
  /** Filter to only members available for the entire given period */
  matchesWholePeriod?: DateRangeRequest;
}

/**
 * Request body for POST /api/team/members/short/search
 * Matches FindShortTeamMembersRequest from swagger
 */
export interface FindShortTeamMembersRequest {
  filter?: FindShortTeamMembersFilterRequest;
  pagination: CursorPaginationParametersRequest;
}
